import { render, staticRenderFns } from "./audits.vue?vue&type=template&id=80d633a2&"
import script from "./audits.vue?vue&type=script&lang=ts&"
export * from "./audits.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports